var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "chartNotFound" } }, [
    _c("div", { staticClass: "svg-container" }, [
      _c(
        "svg",
        {
          attrs: {
            viewBox: "0 0 1049 372",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "backtracking",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Artboard",
                    transform: "translate(-5798.000000, -2590.000000)",
                  },
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group",
                        transform: "translate(5799.000000, 2590.000000)",
                      },
                    },
                    [
                      _c("line", {
                        attrs: {
                          x1: "0.5",
                          y1: "243.5",
                          x2: "1045.5",
                          y2: "243.5",
                          id: "Line",
                          stroke: "#E7EBF1",
                          "stroke-linecap": "square",
                        },
                      }),
                      _vm._v(" "),
                      _c("line", {
                        attrs: {
                          x1: "0.5",
                          y1: "121.5",
                          x2: "1045.5",
                          y2: "121.5",
                          id: "Line",
                          stroke: "#E7EBF1",
                          "stroke-linecap": "square",
                        },
                      }),
                      _vm._v(" "),
                      _c("line", {
                        attrs: {
                          x1: "0.5",
                          y1: "0.5",
                          x2: "1045.5",
                          y2: "0.5",
                          id: "Line",
                          stroke: "#E7EBF1",
                          "stroke-linecap": "square",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M1,243 C32.2894762,166.89952 66.4561429,128.39952 103.5,127.5 C159.065786,126.15072 144.621905,258.709577 227,238 C309.378095,217.290423 287.861621,43.5134257 372,60 C456.138379,76.4865743 446.98965,296 523,296 C599.01035,296 625.688884,78.5932385 676,60 C726.311116,41.4067615 736.906606,193.503253 799,194 C861.093394,194.496747 862.366139,59.6813573 926,62 C968.422574,63.5457618 1008.42257,111.545762 1046,206 L1046,372 L1,372 L1,243 Z",
                          id: "Line-2",
                          "fill-opacity": "0.666111233",
                          fill: "#F8F9FB",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M1,243 C32.2894762,166.89952 66.4561429,128.39952 103.5,127.5 C159.065786,126.15072 144.621905,258.709577 227,238 C309.378095,217.290423 287.861621,43.5134257 372,60 C456.138379,76.4865743 446.98965,296 523,296 C599.01035,296 625.688884,78.5932385 676,60 C726.311116,41.4067615 736.906606,193.503253 799,194 C861.093394,194.496747 862.366139,59.6813573 926,62 C968.422574,63.5457618 1008.42257,111.545762 1046,206",
                          id: "Line-2",
                          stroke: "#ABB9CD",
                          "stroke-width": "2",
                          "stroke-linecap": "square",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "not-found-content" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "alert-text" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.title || _vm.$t("chatbotv2.inMaintenance")) +
            "\n        "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "image-container" }, [
      _c("img", { attrs: { src: "/static/img/empty-chart.png" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }